import { Link, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
`;

const NotFoundPage = () => {
  const { formatMessage } = useIntl();

  return (
    <Container>
      <Helmet>
        <title>{formatMessage({ id: 'containers.NotFoundPage.helmetTitle' })}</title>
      </Helmet>
      <h4>{formatMessage({ id: 'containers.NotFoundPage.title' })}</h4>
      <Link to="/">{formatMessage({ id: 'containers.NotFoundPage.linkBack' })}</Link>
    </Container>
  );
};

export const AgreementNotFoundPage = () => {
  const history = useHistory();
  const { formatMessage } = useIntl();

  const handleGoBack = (event) => {
    event.preventDefault();
    history.goBack();
  };

  return (
    <Container>
      <Helmet>
        <title>{formatMessage({ id: 'containers.AgreementNotFoundPage.helmetTitle' })}</title>
      </Helmet>
      <h4>{formatMessage({ id: 'containers.AgreementNotFoundPage.title' })}</h4>
      <Link to="#" onClick={handleGoBack}>
        {formatMessage({ id: 'containers.AgreementNotFoundPage.linkBack' })}
      </Link>
    </Container>
  );
};

export default NotFoundPage;
